export const userActions = {
    setUser
};

function setUser(user) {
    return dispatch => {
      return dispatch({ type: "SET_USER", payload: user });
    };
}